import React from 'react';
import { DollarSignIcon, BookOpenIcon } from 'lucide-react';
import { currencyOptions, frequencyOptions, shippingOptions, countryOptions } from '../../../data/productManagerData';
import type { PM } from './useProductManager';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
interface PricingSectionProps {
  pm: PM;
}
export const PricingSection: React.FC<PricingSectionProps> = ({
  pm
}) => {
  const dk = useDarkClasses();
  const {
    productType,
    bookForm,
    setBookForm,
    merchForm,
    setMerchForm,
    bookBoxForm,
    setBookBoxForm
  } = pm;
  return <>
      {/* Pricing & Inventory (non-book, non-event, non-creative, non-service) */}
      {productType !== 'event' && productType !== 'creative' && productType !== 'service' && productType !== 'book' && <div className={`p-6 rounded-xl shadow-sm ${dk.card}`} data-id="element-21006" data-mp="2ixsduk5a7hrb">
            <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textHeading}`} data-id="element-21007" data-mp="2mz3va2e04wof">
              <DollarSignIcon className="w-5 h-5 mr-2 text-purple-500" data-id="element-21008" data-mp="2nfzktjnlcfvk" />
              Pricing & Inventory
            </h2>
            <div className="space-y-4" data-id="element-21009" data-mp="2iizpa2odavip">
              <div data-id="element-21010" data-mp="2dr7yps57opsk">
                <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-21011" data-mp="2dqpvuco1ndbo">
                  Price
                </label>
                <div className="relative" data-id="element-21012" data-mp="23t1xlcr8bnor">
                  <span className={`absolute left-3 top-1/2 transform -translate-y-1/2 ${dk.textMuted}`} data-id="element-21013" data-mp="23u389g4c285y">
                    $
                  </span>
                  <input type="number" value={productType === 'merch' ? merchForm.price : bookBoxForm.price || ''} onChange={e => {
              const val = parseFloat(e.target.value);
              if (productType === 'merch') setMerchForm({
                ...merchForm,
                price: val
              });else setBookBoxForm({
                ...bookBoxForm,
                price: val
              });
            }} className={`w-full pl-8 pr-3 py-2 rounded-md border ${dk.inputOnCard}`} placeholder="0.00" data-id="element-21014" data-mp="1utooil70p14k" />
                </div>
              </div>
              {productType === 'merch' && <div data-id="element-21015" data-mp="1rb7n7hvnd1a7">
                  <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-21016" data-mp="1r9wi9eqgtnhi">
                    Inventory Count
                  </label>
                  <input type="number" value={merchForm.inventory || ''} onChange={e => setMerchForm({
            ...merchForm,
            inventory: parseInt(e.target.value)
          })} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} placeholder="0" data-id="element-21017" data-mp="fuhlaay9avme" />
                </div>}
              {productType === 'bookbox' && <>
                  <div data-id="element-21018" data-mp="2gbdr0exvh5ld">
                    <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-21019" data-mp="2gcyl63g9ymip">
                      Currency
                    </label>
                    <select value={bookBoxForm.currency || 'USD'} onChange={e => setBookBoxForm({
              ...bookBoxForm,
              currency: e.target.value
            })} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-21020" data-mp="2p58wjo2woy1j">
                      {currencyOptions.map(c => <option key={c} value={c} data-id="element-21021" data-mp="2aadec8nom39k">
                          {c}
                        </option>)}
                    </select>
                  </div>
                  <div data-id="element-21022" data-mp="2k0g7q9yptj8f">
                    <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-21023" data-mp="2k0pxpxjrfqe4">
                      Frequency
                    </label>
                    <select value={bookBoxForm.frequency || 'Monthly'} onChange={e => setBookBoxForm({
              ...bookBoxForm,
              frequency: e.target.value
            })} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-21024" data-mp="2t0lbma4p9zhu">
                      {frequencyOptions.map(f => <option key={f} value={f} data-id="element-21025" data-mp="111i9tkxb4dgg">
                          {f}
                        </option>)}
                    </select>
                  </div>
                  <div data-id="element-21026" data-mp="rbyq6d1rsfkj">
                    <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-21027" data-mp="rbfkbupe9hmv">
                      Shipping
                    </label>
                    <select value={bookBoxForm.shipping || ''} onChange={e => setBookBoxForm({
              ...bookBoxForm,
              shipping: e.target.value
            })} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-21028" data-mp="1k160saei0vm5">
                      <option value="" data-id="element-21029" data-mp="3usxnvpy4w2hh">Select...</option>
                      {shippingOptions.map(s => <option key={s} value={s} data-id="element-21030" data-mp="3pst7s11519rs">
                          {s}
                        </option>)}
                    </select>
                  </div>
                  <div data-id="element-21031" data-mp="2lupiye0b1czy">
                    <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-21032" data-mp="2lv7e17b8dl6a">
                      Country
                    </label>
                    <select value={bookBoxForm.locationCountry || ''} onChange={e => setBookBoxForm({
              ...bookBoxForm,
              locationCountry: e.target.value
            })} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-21033" data-mp="2cthknvxsgc5v">
                      <option value="" data-id="element-21034" data-mp="1u26wvnnd0fi7">Select...</option>
                      {countryOptions.map(c => <option key={c} value={c} data-id="element-21035" data-mp="1k6dmoax44y3l">
                          {c}
                        </option>)}
                    </select>
                  </div>
                  <div data-id="element-21036" data-mp="10mer4akyvb0e">
                    <label className={`block text-sm font-medium mb-1 ${dk.textSecondary}`} data-id="element-21037" data-mp="wji4m8sb2ur6">
                      Subscription URL
                    </label>
                    <input type="text" value={bookBoxForm.subscriptionUrl || ''} onChange={e => setBookBoxForm({
              ...bookBoxForm,
              subscriptionUrl: e.target.value
            })} className={`w-full p-2 rounded-md border ${dk.inputOnCard}`} placeholder="https://..." data-id="element-21038" data-mp="15j560ul1c0k8" />
                  </div>
                </>}
            </div>
          </div>}
    </>;
};